import { scopedTranslation } from '@utils/I18n'
import type { User } from '@frontend/graphql/types.generated'

import { DetailRow } from './GroupDetailsPanel'

const t = scopedTranslation('shared')

type LeaderNamesProps = {
  leaderType: 'captains' | 'vice-captains'
  leaders: Array<Pick<User, 'firstName' | 'lastName'>>
}

const LeaderNames = ({ leaderType, leaders }: LeaderNamesProps) => {
  const leadersWithNames = leaders.filter(({ firstName, lastName }) => firstName && lastName)
  const leadersFullNames = leadersWithNames.map(({ firstName, lastName }) => [firstName, lastName].join(' ').trim())

  return (
    <DetailRow icon="star-01" label={t(`labels.${leaderType}`)} testId={leaderType}>
      {leadersFullNames.length > 0 ? (
        leadersFullNames.join(', ')
      ) : (
        <span className="tw:italic tw:text-gray-true-500">{t('labels.none')}</span>
      )}
    </DetailRow>
  )
}

export default LeaderNames
